{
  "fi": {
    "start": "Aloita",
    "next": "Seuraava",
    "previous": "Edellinen",
    "close": "Sulje",
    "skip": "Ohita",
    "continue": "Jatka",
    "thankYou": "Kiitos",
    "thankYouContact": "Kiitos yhteydenotostasi",
    "or": "tai",
    "and": "ja",
    "call": "Soita",
    "minutes": "minuuttia",
    "hour": "tunti",
    "hours": "tuntia",
    "backFrontpage": "Palaa etusivulle",
    "login": "Kirjaudu sisään",
    "logout": "Kirjaudu ulos",
    "contact": "Ota yhteyttä",
    "download": "Lataa",
    "delete": "Poista",
    "customer": "Asiakas",
    "interpreter": "Tulkki",
    "news": "Ajankohtaista",
    "readMore": "LUE LISÄÄ",
    "showMore": "Näytä lisää",
    "order": "Tilaa",
    "send": "Lähetä",
    "loading": "Lataa...",
    "dateError": "Tarkasta varauksen ajankohta",
    "username": "Sähköpostiosoite tai käyttäjätunnus",
    "password": "Salasana",
    "booking": "Tee etätulkin ajanvaraus",
    "onSite": "Tilaa tulkki paikan päälle",
    "indicatesRequired": "vaaditaan",
    "sendApplication": "Lähetä hakemus",
    "stories": "Tulkkien uratarinat",
    "alertMissingDetails": "HUOM. Tilauksen tietoja puuttuu. Tarkista kielet, ajankohta ja muut tiedot palaamalla alkuun",
    "here": "tästä",
    "alertEmailConfirmFail": "Sähköpostit eivät täsmää",
    "alertSubmitFailed": "Tietojen lähetys epäonnistui. Ota yhteyttä",
    "inFinnish": ""
  },
  "en": {
    "start": "Start",
    "next": "Next",
    "previous": "Previous",
    "close": "Close",
    "skip": "skip",
    "continue": "Continue",
    "thankYou": "Thank You",
    "or": "or",
    "and": "and",
    "call": "Call",
    "minutes": "minutes",
    "hour": "hour",
    "hours": "hours",
    "backFrontpage": "Back to frontpage",
    "login": "Login",
    "logout": "Logout",
    "contact": "Contact us",
    "download": "Download",
    "delete": "Delete",
    "customer": "Customer",
    "interpreter": "Interpreter",
    "news": "Insights",
    "readMore": "READ MORE",
    "showMore": "Show more",
    "order": "Order",
    "send": "Send",
    "loading": "Loading...",
    "dateError": "Check the time of booking",
    "username": "Email or username",
    "password": "Password",
    "booking": "Booking",
    "onSite": "I need an interpreter on-site",
    "indicatesRequired": "indicates required",
    "stories": "Stories",
    "alertMissingDetails": "NOTE. Order information is missing. Please check the languages, date, and other details by returning to the beginning",
    "here": "here",
    "alertEmailConfirmFail": "Email addresses do not match",
    "alertSubmitFailed": "Failed to send the form. Please contact us",
    "sendApplication": "",
    "thankYouContact": "",
    "inFinnish": "(in Finnish)"
  },
  "ru": {
    "start": "Начать",
    "next": "Следующая страница",
    "previous": "Предыдущая страница",
    "close": "Закрыть",
    "skip": "Пропустить",
    "continue": "Продолжить",
    "thankYou": "Спасибо",
    "or": "или",
    "and": "и",
    "call": "Позвонить",
    "minutes": "минут",
    "hour": "час",
    "hours": "часa",
    "backFrontpage": "Перейти на начальную страницу",
    "login": "Войти",
    "logout": "Выйти",
    "contact": "Свяжитесь с нами",
    "download": "Lataa",
    "delete": "Удалить",
    "customer": "Клиент",
    "interpreter": "Переводчик",
    "news": "Актуальное",
    "readMore": "Читать дальше",
    "showMore": "Показать больше",
    "order": "Сделать заказ",
    "send": "Отправить",
    "loading": "Загружается...",
    "dateError": "Проверьте время бронирования.",
    "indicatesRequired": "Обязательно указать:",
    "booking": "Забронировать удалённый перевод",
    "onSite": "Заказать переводчика на место",
    "alertMissingDetails": "HUOM. Tilauksen tietoja puuttuu. Tarkista kielet, ajankohta ja muut tiedot palaamalla alkuun",
    "here": "здесь",
    "alertEmailConfirmFail": "Sähköpostit eivät täsmää",
    "alertSubmitFailed": "Failed to send the form. Please contact us",
    "password": "",
    "sendApplication": "",
    "stories": "",
    "thankYouContact": "",
    "username": "",
    "inFinnish": "(на финском)"
  },
  "sv": {
    "start": "Start",
    "next": "Nästa",
    "previous": "Föregående",
    "close": "Stäng av",
    "skip": "hoppa över",
    "continue": "Fortsätt",
    "thankYou": "Tack",
    "or": "eller",
    "and": "och",
    "call": "Ring",
    "minutes": "minuter",
    "hour": "timme",
    "hours": "timmar",
    "backFrontpage": "Tillbaka till början",
    "login": "Logga in",
    "logout": "Logga ut",
    "contact": "Ta kontakt",
    "download": "Ladda",
    "delete": "Radera",
    "customer": "Kund",
    "interpreter": "Tolk",
    "news": "Insikter",
    "readMore": "LÄS MER OM",
    "showMore": "Visa mer",
    "order": "Order",
    "send": "Skicka",
    "loading": "Laddar...",
    "dateError": "Check the time of booking",
    "username": "e-postadress eller användarnamn",
    "password": "Lösenord",
    "booking": "Tidsbeställning av tolk",
    "onSite": "Behöver tolk på plats",
    "alertMissingDetails": "HUOM. Tilauksen tietoja puuttuu. Tarkista kielet, ajankohta ja muut tiedot palaamalla alkuun",
    "here": "denna",
    "alertEmailConfirmFail": "Sähköpostit eivät täsmää",
    "alertSubmitFailed": "Failed to send the form. Please contact us",
    "indicatesRequired": "",
    "sendApplication": "",
    "stories": "",
    "thankYouContact": "",
    "inFinnish": "(på finska)"
  },
  "de": {
    "start": "Aloita",
    "next": "Seuraava",
    "previous": "Edellinen",
    "close": "Sulje",
    "skip": "Ohita",
    "continue": "Weiter",
    "thankYou": "vielen Dank",
    "or": "oder",
    "and": "und",
    "call": "Rufen Sie uns unter",
    "minutes": "minute",
    "hour": "stunde",
    "hours": "tuntia",
    "backFrontpage": "Zurück zur Startseite",
    "contact": "Kontaktieren Sie uns",
    "download": "Lataa",
    "delete": "Poista",
    "customer": "Asiakas",
    "interpreter": "Tulkki",
    "news": "Aktuelles",
    "readMore": "LUE LISÄÄ",
    "showMore": "Mehr anzeigen",
    "order": "Tilaa",
    "send": "Senden",
    "loading": "Lataa...",
    "dateError": "Tarkasta varauksen ajankohta",
    "username": "Sähköpostiosoite tai käyttäjätunnus",
    "password": "Salasana",
    "booking": "Dolmetscher buchen",
    "onSite": "Dolmetscher vor Ort buchen",
    "indicatesRequired": "vaaditaan",
    "sendApplication": "Lähetä hakemus",
    "alertMissingDetails": "HUOM. Tilauksen tietoja puuttuu. Tarkista kielet, ajankohta ja muut tiedot palaamalla alkuun",
    "here": "hier",
    "alertEmailConfirmFail": "Sähköpostit eivät täsmää",
    "alertSubmitFailed": "Failed to send the form. Please contact us",
    "login": "",
    "logout": "",
    "stories": "",
    "thankYouContact": "",
    "inFinnish": "(auf Finnisch)"
  },
  "is": {
    "start": "Byrja",
    "next": "Næsta",
    "previous": "Fyrri",
    "close": "Loka",
    "skip": "sleppa",
    "continue": "Halda áfram",
    "thankYou": "Takk fyrir",
    "or": "eða",
    "and": "og",
    "call": "Hringja",
    "minutes": "mínútur",
    "hour": "klukkustund",
    "hours": "klukkustundir",
    "backFrontpage": "Til baka á upphafssíðu",
    "login": "Innskráning",
    "logout": "Útskráning",
    "contact": "Hafðu samband",
    "download": "Sækja",
    "delete": "Eyða",
    "customer": "Viðskiptavinur",
    "interpreter": "Túlkur",
    "news": "Fréttir",
    "order": "Bóka",
    "send": "Senda",
    "loading": "Hleður ...",
    "dateError": "Athugaðu tíma bókunarinnar",
    "username": "Netfang eða notandanafn",
    "password": "Aðgangsorð",
    "booking": "Bókun",
    "onSite": "Ég þarf túlk á staðinn",
    "indicatesRequired": "gefur til kynna áskilda reiti",
    "readMore": "LESA MEIRA",
    "showMore": "Sýna meira",
    "alertMissingDetails": "ATH. Pöntunarupplýsingar vantar. Vinsamlegast athugaðu tungumál, dagsetningu og aðrar upplýsingar með því að fara aftur í upphafið",
    "here": "héðan",
    "alertEmailConfirmFail": "Netföngin passa ekki saman",
    "alertSubmitFailed": "Mistókst að senda eyðublaðið. Vinsamlegast hafið samband við okkur",
    "sendApplication": "",
    "stories": "",
    "thankYouContact": "",
    "inFinnish": "(á finnsku)"
  },
  "ee": {
    "start": "Algus",
    "next": "Järgmine",
    "previous": "Eelmine",
    "close": "Sulge",
    "skip": "Jäta vahele",
    "continue": "Jätka",
    "thankYou": "Aitäh!",
    "or": "või",
    "and": "ja",
    "call": "Helista",
    "minutes": "minutit",
    "hour": "tund",
    "hours": "tundi",
    "backFrontpage": "Tagasi avalehele",
    "login": "Logi sisse",
    "logout": "Logi välja",
    "contact": "Võta meiega ühendust",
    "download": "Allalaadimine",
    "delete": "Kustuta",
    "customer": "Klient",
    "interpreter": "Tõlk",
    "news": "Uudised",
    "readMore": "Loe edasi",
    "showMore": "Näita rohkem",
    "order": "Tellimus",
    "send": "Saada",
    "loading": "Laadimine...",
    "dateError": "Kontrolli broneeritud aega",
    "username": "Meiliaadress või kasutajanimi",
    "password": "Parool",
    "booking": "Broneering",
    "onSite": "Vajan tõlki kohapeale",
    "indicatesRequired": "näitab nõutavat",
    "alertMissingDetails": "MÄRKUS. Tellimuse teave puudub. Palun vaata üle keeled, kuupäev ja muud üksikasjad, naastes siit algusesse.",
    "here": "siit",
    "alertEmailConfirmFail": "Meiliaadressid ei ühti",
    "alertSubmitFailed": "Vormi saatmine ebaõnnestus. Palun võtke meiega ühendust",
    "sendApplication": "",
    "stories": "",
    "thankYouContact": "",
    "inFinnish": "(soome keeles)"
  },
  "is-en": {
    "start": "Start",
    "next": "Next",
    "previous": "Previous",
    "close": "Close",
    "skip": "skip",
    "continue": "Continue",
    "thankYou": "Thank You",
    "or": "or",
    "and": "and",
    "call": "Call",
    "minutes": "minutes",
    "hour": "hour",
    "hours": "hours",
    "backFrontpage": "Back to frontpage",
    "login": "Login",
    "logout": "Logout",
    "contact": "Contact us",
    "download": "Download",
    "delete": "Delete",
    "customer": "Customer",
    "interpreter": "Interpreter",
    "news": "Insights",
    "readMore": "READ MORE",
    "showMore": "Show more",
    "order": "Order",
    "send": "Send",
    "loading": "Loading...",
    "dateError": "Check the time of booking",
    "username": "Email or username",
    "password": "Password",
    "booking": "Booking",
    "onSite": "I need an interpreter on-site",
    "indicatesRequired": "indicates required",
    "stories": "Stories",
    "alertMissingDetails": "NOTE. Order information is missing. Please check the languages, date, and other details by returning to the beginning",
    "here": "here",
    "alertEmailConfirmFail": "Email addresses do not match",
    "alertSubmitFailed": "Failed to send the form. Please contact us",
    "sendApplication": "",
    "thankYouContact": "",
    "inFinnish": "(in Finnish)"
  },
  "ee-en": {
    "start": "Start",
    "next": "Next",
    "previous": "Previous",
    "close": "Close",
    "skip": "skip",
    "continue": "Continue",
    "thankYou": "Thank You",
    "or": "or",
    "and": "and",
    "call": "Call",
    "minutes": "minutes",
    "hour": "hour",
    "hours": "hours",
    "backFrontpage": "Back to frontpage",
    "login": "Login",
    "logout": "Logout",
    "contact": "Contact us",
    "download": "Download",
    "delete": "Delete",
    "customer": "Customer",
    "interpreter": "Interpreter",
    "news": "Insights",
    "readMore": "READ MORE",
    "showMore": "Show more",
    "order": "Order",
    "send": "Send",
    "loading": "Loading...",
    "dateError": "Check the time of booking",
    "username": "Email or username",
    "password": "Password",
    "booking": "Booking",
    "onSite": "I need an interpreter on-site",
    "indicatesRequired": "indicates required",
    "stories": "Stories",
    "alertMissingDetails": "NOTE. Order information is missing. Please check the languages, date, and other details by returning to the beginning",
    "here": "here",
    "alertEmailConfirmFail": "Email addresses do not match",
    "alertSubmitFailed": "Failed to send the form. Please contact us",
    "sendApplication": "",
    "thankYouContact": "",
    "inFinnish": "(in Finnish)"
  },
  "ee-ru": {
    "start": "Начать",
    "next": "Дальше",
    "previous": "Назад",
    "close": "Закрыть",
    "skip": "Пропустить",
    "continue": "Продолжить",
    "thankYou": "Спасибо!",
    "thankYouContact": "Спасибо за обращение",
    "or": "или",
    "and": "и",
    "minutes": "минут(ы)",
    "hour": "час",
    "hours": "часа(-ов)",
    "backFrontpage": "На главную страницу",
    "login": "Войти",
    "logout": "Выйти",
    "contact": "Свяжитесь с нами",
    "download": "Скачать",
    "delete": "Удалить",
    "customer": "Клиент",
    "interpreter": "Переводчик",
    "readMore": "Читать далее",
    "showMore": "Показать больше",
    "order": "Заказ",
    "send": "Отправить",
    "loading": "Загрузка...",
    "dateError": "Проверьте забронированное время",
    "username": "Адрес электронной почты или имя пользователя",
    "password": "Пароль",
    "booking": "Бронирование",
    "onSite": "Переводчик требуется на место",
    "indicatesRequired": "Обязательное поле",
    "alertMissingDetails": "ВНИМАНИЕ. Информация о заказе отсутствует. Пожалуйста, проверьте языки, дату и другие детали, вернувшись в начало",
    "here": "здесь",
    "alertEmailConfirmFail": "Адреса электронной почты не совпадают",
    "alertSubmitFailed": "Ошибка при отправке формы. Пожалуйста, свяжитесь с нами",
    "sendApplication": "Отправить заявление о работе",
    "stories": "Истории",
    "inFinnish": "(на финском)"
  }
}